import {Button, Grid, MuiThemeProvider} from '@material-ui/core';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import React from 'react';
import {useDispatch} from 'react-redux';
import CardContainer from '../../../componentsOld/common/CardContainer';
import TaskManyTable from '../../../modules/task/List/TaskManyTable';
import {editNewTask} from '../../../actions/tasks';
import {colors} from '../../../ui/theme';
import green from '../../../ui/theme/green';

function AddTaskButton({onClick}) {
  return (
    <>
      <MuiThemeProvider theme={green}>
        <Button
          onClick={onClick}
          variant={'contained'}
          color={'primary'}
        >
          Add Task
        </Button>
      </MuiThemeProvider>
    </>
  );
}

export const SalesDocTasksTab = ({salesDoc}) => {
  const dispatch = useDispatch();

  const handleAddTask = () => {
    dispatch(editNewTask({
      quoteIds: [salesDoc._id],
      quotes: [salesDoc]
    }));
  };

  return (
    <CardContainer
      title={'Tasks'}
      icon={<AssignmentTurnedInIcon />}
      iconBackgroundColor={colors.purple}
      buttonComponent={<AddTaskButton onClick={handleAddTask} />}
    >
      <Grid container>
        <Grid item xs={12} alignContent='center' justifyContent='center'>
          <TaskManyTable
            filterToMe={false}
            queryStateId={'quoteTaskMany' + salesDoc._id}
            fixedFilter={{quoteIds: [salesDoc._id]}}
          />
        </Grid>
      </Grid>
    </CardContainer>
  );
};
